/**
 * @generated SignedSource<<6cec09bbdfdcdab23076a135e726a182>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FAILED" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "IN_PROGRESS" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
export type ZnglyVideoMediaNameEnum = "AUDIO" | "EMBED" | "IMAGE" | "LINK" | "MIXCLOUD" | "MP4" | "OTHER" | "PDF" | "SHAREPOINT" | "SOUNDCLOUD" | "SPOTIFY" | "SYNTHESIA" | "TED" | "UNDEFINED" | "VIMEO" | "YOUTUBE";
export type ZnglyVideoPostTypeEnum = "EMBED" | "EXTERNAL" | "FILE";
export type UpdateZnglyVideoInput = {
  aiSummary?: string | null | undefined;
  authorId?: string | null | undefined;
  categories?: ZnglyVideoCategoriesInput | null | undefined;
  clientMutationId?: string | null | undefined;
  content?: string | null | undefined;
  contentEmbedHtml?: string | null | undefined;
  contentFile?: string | null | undefined;
  contentLink?: string | null | undefined;
  contentMediaName?: ZnglyVideoMediaNameEnum | null | undefined;
  contentMediaType?: ZnglyVideoPostTypeEnum | null | undefined;
  ctaLink?: string | null | undefined;
  ctaName?: string | null | undefined;
  date?: string | null | undefined;
  excerpt?: string | null | undefined;
  featuredImageFile?: string | null | undefined;
  featuredImageLink?: string | null | undefined;
  formId?: string | null | undefined;
  htmlDesc?: string | null | undefined;
  id: string;
  ignoreEditLock?: boolean | null | undefined;
  menuOrder?: number | null | undefined;
  password?: string | null | undefined;
  shortText?: string | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusSettings?: StatusSettingsInput | null | undefined;
  tags?: ZnglyVideoTagsInput | null | undefined;
  title?: string | null | undefined;
  videoDuration?: string | null | undefined;
};
export type ZnglyVideoCategoriesInput = {
  append?: boolean | null | undefined;
  nodes?: ReadonlyArray<ZnglyVideoCategoriesNodeInput | null | undefined> | null | undefined;
};
export type ZnglyVideoCategoriesNodeInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  slug?: string | null | undefined;
};
export type StatusSettingsInput = {
  approved?: ApprovedStateInput | null | undefined;
  stateWhenApproved?: StateWhenApprovedInput | null | undefined;
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type ApprovedStateInput = {
  id?: string | null | undefined;
};
export type StateWhenApprovedInput = {
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type UIPermissionInput = {
  type?: StatusUiPermissionEnum | null | undefined;
};
export type ZnglyVideoTagsInput = {
  append?: boolean | null | undefined;
  nodes?: ReadonlyArray<ZnglyVideoTagsNodeInput | null | undefined> | null | undefined;
};
export type ZnglyVideoTagsNodeInput = {
  description?: string | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  slug?: string | null | undefined;
};
export type Content_UpdateStatus_Mutation$variables = {
  input: UpdateZnglyVideoInput;
};
export type Content_UpdateStatus_Mutation$data = {
  readonly updateZnglyVideo: {
    readonly znglyVideo: {
      readonly id: string;
      readonly status: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Content_UpdateStatus_Mutation$rawResponse = {
  readonly updateZnglyVideo: {
    readonly znglyVideo: {
      readonly id: string;
      readonly status: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Content_UpdateStatus_Mutation = {
  rawResponse: Content_UpdateStatus_Mutation$rawResponse;
  response: Content_UpdateStatus_Mutation$data;
  variables: Content_UpdateStatus_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateZnglyVideoPayload",
    "kind": "LinkedField",
    "name": "updateZnglyVideo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZnglyVideo",
        "kind": "LinkedField",
        "name": "znglyVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Content_UpdateStatus_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Content_UpdateStatus_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9429beaf39e5decd1907851ce4439c72",
    "id": null,
    "metadata": {},
    "name": "Content_UpdateStatus_Mutation",
    "operationKind": "mutation",
    "text": "mutation Content_UpdateStatus_Mutation(\n  $input: UpdateZnglyVideoInput!\n) {\n  updateZnglyVideo(input: $input) {\n    znglyVideo {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f4d351f4f7859efbcccce7282be59d3b";

export default node;
